import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { ConnectedRouter, routerMiddleware } from "react-router-redux";
import { Helmet } from "react-helmet";
import { composeWithDevTools } from "redux-devtools-extension";
import { createHashHistory } from "history";
import thunk from "redux-thunk";
import "es6-promise/auto";
import "setimmediate";
import createReduxPromiseListener from "redux-promise-listener";

import { ConfigProvider } from "antd";
import enGB from "antd/lib/locale-provider/en_GB";
import "./favicon.ico";

import Layout from "components/LayoutComponents/Layout";
import reducer from "ducks";
import { rootEpic } from "epics";
import { googleAnalytics } from "./reactGAMiddleware";
import ReactGA from "react-ga";

import "resources/_antd.less"; // redefinition AntDesign variables
import "bootstrap/dist/css/bootstrap.min.css"; // bootstrap styles

import "resources/AntStyles/AntDesign/antd.cleanui.scss";
import "resources/CleanStyles/Core/core.cleanui.scss";
import "resources/CleanStyles/Vendors/vendors.cleanui.scss";

if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("UA-130881791-2");
} else {
  ReactGA.initialize("UA-130881791-3");
}
const history = createHashHistory();
const router = routerMiddleware(history);
const epicMiddleware = createEpicMiddleware();
const reduxPromiseListener = createReduxPromiseListener();
const middlewares = [
  router,
  epicMiddleware,
  thunk,
  reduxPromiseListener.middleware,
  googleAnalytics
];
const isLogger = true;
if (isLogger && process.env.NODE_ENV === "development") {
  const { logger } = require("redux-logger");
  middlewares.push(logger);
}

const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(...middlewares))
);

epicMiddleware.run(rootEpic);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ConfigProvider locale={enGB}>
        <div>
          <link
            href="https://fonts.googleapis.com/css?family=Barlow:400,400i,500,500i,600,600i,700,700i|Frank+Ruhl+Libre:400,500,700"
            rel="stylesheet"
          />
          <Helmet titleTemplate="%s" />
          <Layout />
        </div>
      </ConfigProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
//registerServiceWorker();
export const promiseListener = reduxPromiseListener;
//export const history = history;


// WEBPACK FOOTER //
// ./src/index.js